import * as React from 'react';
import { GenericService } from '../GenericService';
import { ServicePrice } from '../ServicePrice';
import * as styles from './PremiumService.css';
import { IService } from '../../types';
import { useSelector } from 'react-redux';
import { selectBaseAuctionBetByServiceId } from '../../../../../../../../../selectors/auction';

export const PremiumService = ({ selected, blurred, disabled, onSelect, type }: IService) => {
  const price: number = useSelector(selectBaseAuctionBetByServiceId(type));

  return (
    <GenericService
      title="Премиум"
      subtitle="До х3 звонков"
      serviceType={type}
      className={styles.root}
      selected={selected}
      disabled={disabled}
      blurred={blurred}
      onSelect={onSelect}
    >
      <ServicePrice price={price} suffix="₽/день" />
    </GenericService>
  );
};
